export default __webpack_public_path__ + "static/media/ic_azores_islands.edae8272.svg";